import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() { }

  public eval = null

  public setEval(newEval){
    this.eval = newEval
  }
}
